import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { MFReports } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import axiosInstance from "../../CommonMethhods/axiosInstance";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import CommonSearch from "../../CommonMethhods/CommonSearch";
import MFFundHoldingReportTable from "../../Components/ReportTables/MFFundHoldingReportTable";

function MfFundHoldingReportSidebar() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorGrid, setErrorGrid] = useState(false);
  const [serverError, setServerError] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const [clientCode, setClientCode] = useState("");

  const [tableData, setTableData] = useState([]);
  const [dataCount, setDataCount] = useState();
  const [offset, setOffset] = useState(1);
  const [scrollLoaderTable, setScrollLoaderTable] = useState(false);
  const tableBodyRef = useRef(null);

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");


  const getFundHoldingReport = async (fileView, offsetTab) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }

    if (fileView === "grid" && offsetTab <= 1) {
      setLoader(true);
    }

    let payloadValue = {
      userId: clientCode,
      fileType: fileView,
      pageNo: fileView === "grid" ? offsetTab : -1,
      pageSize: fileView === "grid" ? 10 : -1,
      fromDate,
      endDate: toDate,
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        MFReports.Fund_Holding,
        `"${encPayload}"`,

      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          setDataCount(res?.data?.totalCount);
          if (offsetTab > 1) {
            setTableData((prev) => {
              return [...prev, ...res?.data?.fundHoldingList];
            });
          } else {
            setTableData(res?.data?.fundHoldingList);
          }
          setScrollLoaderTable(false);
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setTableData([]);
        if (fileView !== "grid") {
          setServerError(res?.message);
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
    }
  };

  const handleFromDateChange = (e) => {
    setFromDateError(false);
    setErrorGrid(false);
    setFromDate(e.target.value);
    setToDate(e.target.value);
    setServerError(false);
  };

  const handleOnClick = (e) => {
    setOffset(1);
    const value = e.target.value;
    if (!value || !clientCode) {
      setTableData([]);
      return;
    }
    getFundHoldingReport(value, 1);
  };


  const handleTableScroll = (e) => {
    console.log("entered");
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scrollLoaderTable) {
      const nextOffset = offset + 1;
      const totalLoadedRecords = offset * 10;

      if (dataCount > totalLoadedRecords && dataCount !== tableData.length) {
        setOffset(nextOffset); // This still updates state for future reference
        setScrollLoaderTable(true);
        setLoader(false);
        getFundHoldingReport("grid", nextOffset);
      } else {
        setScrollLoaderTable(false);
      }
    }
  };



  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">MF Fund Holding Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-6">
              <CommonSearch setDataCount={setDataCount}
              setClientCode={setClientCode}
              clientCode={clientCode} />
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group calendar-icon">
                <label className="form-label">As on Date</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className="datepicker form-control"
                  id="FromDateCombine"
                  onChange={handleFromDateChange}
                  max={DateReverse}
                />
                {toDateError && (
                  <span
                    className="dashboard-to-date-error"
                    style={{ right: 0 }}
                  >
                    {fromDateError}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
              disabled={loader || !clientCode}
            >
              {Constants.Search}
            </button>
          </div>
          <div>
            <ReportTableHeader
              showEmailBtn={false}
              showPdfBtn={false}
              smallLoaderExcel={smallLoaderExcel}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section pnl-wrapper">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : 
              tableData && tableData?.length > 0 ? (
                <MFFundHoldingReportTable
                  tableData={tableData}
                  handleTableScroll={handleTableScroll}
                  scrollLoaderTable={scrollLoaderTable}
                  loader={loader}
                  LoaderForSearch={LoaderForSearch}
                  ref={tableBodyRef}
                  clientDashboard={false}
                />  
            ) : serverError ? (
              <h4 className="report-error-message">{noDataFound(serverError)}</h4>
            ) : errorGrid && (
              noDataFound(errorGrid)
            )}
          </div>
        </div>
      </main >
    </>
  );
}

export default MfFundHoldingReportSidebar;
